import rawRequest from "../rawRequest";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";

const refetchIntervalSeconds = 120; // decide how often to refetch the data per second

// fetch all collections in the db
export const useCollectionsData = (environment) =>
	useQuery({
		queryKey: ["dbCollections", environment],
		queryFn: () => rawRequest({ url: `/${environment}/collectionList`, method: "GET" }),
		refetchInterval: 1000 * refetchIntervalSeconds,
	});

// fetch collection schema
export const useCollectionSchema = (environment, collectionName, sampleSize, noCache) => {
	const [progress, setProgress] = useState(null);
	const [schema, setSchema] = useState(null);
	const [asOf, setAsOf] = useState(null);
	const [cached, setCached] = useState(false);

	const query = useQuery({
		queryKey: ["collection-schema", environment, collectionName, sampleSize, noCache],
		queryFn: async () => {
			const queries = [];
			if (sampleSize) queries.push(`sampleSize=${sampleSize}`);
			if (noCache) queries.push(`noCache=true`);
			const queryString = queries.length ? `?${queries.join('&')}` : '';
			await rawRequest({
				url: `/${environment}/collections/${collectionName}${queryString}`,
				method: "GET",
				responseType: "stream",
				onDownloadProgress: (progressEvent) => {
					// Get only the new part of the response
					const newResponse = progressEvent.event.currentTarget.response;
					// Process new chunks
					const newChunks = newResponse.split("\n").filter(Boolean);
					newChunks.forEach((chunk) => {
						try {
							const parsedChunk = JSON.parse(chunk);
							if (parsedChunk.type === "progress") {
								setProgress(parsedChunk.data.percentage);
							} else if (parsedChunk.type === "complete") {
								setSchema(parsedChunk.result);
								setProgress(null);
								setAsOf(parsedChunk.asOf);
								setCached(!!parsedChunk.cached);
								return parsedChunk.result;
							}
						} catch (e) {}
					});
				},
			});
			return schema;
		},
		enabled: false,
		retry: 0,
	});

	return { ...query, progress, schema, asOf, cached };
};
